import GuidanceRegistry from '../guidance-registry.js';

GuidanceRegistry.register({
    type: "action-item-ewf-guided-setup-pop-coverage",
    prompt: 'Select all of the coverage options offered to participants by the employer on a pre-tax basis. Click Save.',
    openAction: {
        text: 'View Coverage',
        url: (guidanceItem) => `/employer/${guidanceItem.employerId}/plans?planId=${guidanceItem.parameters.planId}`,
        row: "Coverage Options"
    },
    completeAction: {
    }
});


// WEBPACK FOOTER //
// ./src/guidance/items/guidance-pop-coverage.js